import React, { useState } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { DialogContent, TextField } from '@mui/material';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import { useTranslation } from 'react-i18next';
// Icons
import { X } from 'lucide-react';

export default function StopOrderDialog(props) {

    const classes = useStyles();
    const { t } = useTranslation();

    const [problemDescription, setProblemDescription] = useState("");

    const submitProblem = () => {
        if (!props.loading) {
            props.submitProblem(problemDescription);
            setProblemDescription("");
        }
    }

    return (

        <Dialog className={classes.dialog}
            open={props.dialogOpen}
            onClose={props.closeDialog}

            classes={{ paper: classes.dialogPaper }}

            aria-labelledby="draggable-dialog-title"
        >
            <div className={classes.dialog__head}>
                <DialogTitle className={classes.dialog__title} id="draggable-dialog-title">
                    {t("Report a problem")}
                </DialogTitle>
                <button onClick={() => props.closeDialog()} className={classes.dialog__closeButton}>
                    <X size={19} />
                </button>
            </div>
            <DialogContent className={classes.dialog__contentContainer}>
                <div className={classes.dialog__inputContainer} style={{ width: '100%' }}>
                    <label className={classes.dialog__inputLabel}>{t("Describe the problem")}</label>
                    <TextField
                        className={classes.dialog__inputField}
                        id="reason"
                        type="text"
                        value={problemDescription}
                        onChange={(e) => setProblemDescription(e.target.value)}
                        sx={{
                            width: '100%',
                            "& .MuiOutlinedInput-root": {
                                "&.Mui-focused": {
                                    "& .MuiOutlinedInput-notchedOutline": {
                                        borderColor: FlagstoneTheme.palette.primary.main,
                                        borderWidth: '1px',
                                    },
                                },
                            },
                        }}
                        InputProps={{
                            style: {
                                height: '40px',
                                fontFamily: "Lato, sans-serif",
                                fontSize: '16px',
                                color: '#0C0E29',
                            },
                        }}
                    />
                </div>
            </DialogContent>
            <DialogActions className={classes.dialog__buttonContainer}>
                <Button className={classes.dialog__button__secondary} onClick={() => props.closeDialog()}>
                    {t('Cancel')}
                </Button>
                <Button className={classes.dialog__button} disabled={problemDescription.trim().length < 5} onClick={() => submitProblem()}>
                    <span style={{ opacity: props.loading ? 0 : 1 }}>
                        {props.buttonText ? props.buttonText : t('Submit')}
                    </span>
                    {props.loading &&
                        <div className={classes.loader}></div>
                    }
                </Button>
            </DialogActions>
        </Dialog>
    );
}

const useStyles = makeStyles(() => ({
    dialog: {
        margin: "auto"
    },

    dialogPaper: {
        maxWidth: 'calc(100vw - 512px) !important',
        width: '640px !important',
        // height: '400px !important',
        borderRadius: '6px !important',
    },

    // Head
    dialog__head: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',

        padding: '16px 16px 0px 16px !important',
        marginBottom: '16px !important',
    },

    dialog__title: {
        fontSize: '24px !important',
        fontFamily: "Lato, sans-serif !important",
        fontWeight: 'normal',

        padding: '0px !important',
    },

    dialog__closeButton: {
        backgroundColor: '#F5F5F5',
        border: 'none',
        cursor: 'pointer',

        padding: '3px !important',
        height: '25px !important',

        borderRadius: '3px',

        transition: 'all 0.2s',

        '&:hover': {
            backgroundColor: '#D84949',
            color: '#F5F5F5',
        },

        '&:focus': {
            outline: '#4654FB auto 1px',
        },

    },

    // Content
    dialog__contentContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        padding: '0px 16px !important',

        // remove scrollbar
        '&::-webkit-scrollbar': {
            display: 'none',
        },
        '-ms-overflow-style': 'none',
        scrollbarWidth: 'none',

    },

    dialog__inputContainer: {
        width: '50%',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
    },

    dialog__inputLabel: {
        fontSize: '16px',
        fontFamily: "Lato, sans-serif",
        fontWeight: 'normal',
        color: FlagstoneTheme.palette.text.primary,
    },

    dialog__inputField: {
        width: '100%',
        height: '40px !important',
        padding: '0px !important',
    },

    // Dialog actions
    dialog__buttonContainer: {
        width: '100%',
        boxSizing: 'border-box',

        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between !important',

        padding: '16px !important',
        paddingTop: '0px !important',
        margin: '0px !important',
        marginTop: "16px !important",
    },

    dialog__button: {
        color: "white !important",
        fontSize: "16px !important",
        fontWeight: "bold !important",
        fontFamily: "Lato, sans-serif !important",
        backgroundColor: FlagstoneTheme.palette.primary.main + " !important",
        border: "1px solid " + FlagstoneTheme.palette.primary.main + " !important",
        minWidth: "fit-content !important",
        height: '40px !important',
        padding: '0px 20px !important',
        textTransform: 'capitalize !important',
        position: 'relative',

        '&:hover': {
            backgroundColor: "white !important",
            color: FlagstoneTheme.palette.primary.main + " !important",
            border: "1px solid " + FlagstoneTheme.palette.primary.main + " !important",
        },
        '&:disabled': {
            backgroundColor: "lightgrey !important",
            color: "white !important",
            border: "1px solid darkgrey !important",
            cursor: "not-allowed !important"
        },
    },

    dialog__button__secondary: {
        color: FlagstoneTheme.palette.primary.main + " !important",
        fontSize: "16px !important",
        fontWeight: "bold !important",
        fontFamily: "Lato, sans-serif !important",
        backgroundColor: "white !important",
        border: "1px solid " + FlagstoneTheme.palette.primary.main + " !important",
        minWidth: "fit-content !important",
        height: '40px !important',
        padding: '0px 20px !important',
        textTransform: 'capitalize !important',

        '&:hover': {
            backgroundColor: FlagstoneTheme.palette.primary.main + " !important",
            color: "white !important",
            border: "1px solid " + FlagstoneTheme.palette.primary.main + " !important",
        },
        '&:disabled': {
            backgroundColor: "lightgrey !important",
            color: "white !important",
            border: "1px solid darkgrey !important",
            cursor: "not-allowed !important"
        },
    },

    "@global": {
        "@keyframes rotation": {
            "0%": { transform: "rotate(0deg)" },
            "100%": { transform: "rotate(360deg)" },
        },
    },

    loader: {
        width: "24px",
        height: "24px",
        border: "3px solid " + FlagstoneTheme.palette.primary.main,
        borderBottomColor: "transparent",
        borderRadius: "50%",
        display: "inline-block",
        boxSizing: "border-box",
        animation: "rotation 1s linear infinite",

        position: "absolute",
    },
}));
